module.exports = __webpack_public_path__ + "static/media/blog2_pic1.8a28de86.png";